export default __webpack_public_path__ + "static/media/wyndham7.8b824ffb.png";